import React from 'react';
import { useTranslation } from 'react-i18next';

function BtnBack({ backTriggered, iconName, className = '', newButton=false }) {
  const { t } = useTranslation('common');

  return (
    <button
      className={newButton ? `btn btn-white btn-back-lib btn-back-xs ${className}`.trim() : 'btn btn-white btn-back-lib btn-back-xs'}
      onClick={backTriggered}
      type="button"
    >
      {iconName && <i className={`icon-${iconName}`} />}
      <span className="text-icon">{t('APPROVE_REJECTS.BACK')}</span>
    </button>
  );
}

export default BtnBack;
